export default __webpack_public_path__ + "locales/az/FillPDFDialog.json?hash=401d4cfcbb97c47cbe0c971439277b09";